/* Progressive enhancement only: links and <details> work without JavaScript. */
(() => {
  if (window.ppCleanupMenusBound) return;
  window.ppCleanupMenusBound = true;
  const selector = '[data-pp-menu], #pp-home-top .pp-mobile-menu';
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(selector).forEach((menu) => {
      if (!menu.open) return;
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll(selector).forEach((menu) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  });
})();
